const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

if (!prefersReducedMotion) {
  document.documentElement.classList.add('js-scroll-reveal-ready');

  const targets = document.querySelectorAll('[data-scroll-reveal]');

  if (targets.length > 0) {
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries, obs) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              entry.target.classList.add('scroll-reveal--visible');
              obs.unobserve(entry.target);
            }
          }
        },
        { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
      );

      targets.forEach((target) => observer.observe(target));
    } else {
      targets.forEach((target) => target.classList.add('scroll-reveal--visible'));
    }
  }
}
